import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'appv2-simple-pricing',
  templateUrl: './simple-pricing.component.html',
  styleUrls: ['./simple-pricing.component.scss']
})
export class SimplePricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
